import React from 'react'
import { Prompt } from 'react-router'

class Merch extends React.Component {
  constructor() {
    super()

    this.state = {
      isBlocking: true
    }
  }
  render() {
    const { isBlocking } = this.state
    return (
      <div>
        <Prompt
          when={isBlocking}
          message={location => (
            `Warning, navigating away may lose the state of your session! Continue?`
          )}
        />
        <iframe src="https://support.4zzz.org.au/merch" style={{height: '100vh', width: '100vw', marginTop: '62px', border: '0' }} />
      </div>
    )
  }
}

export default Merch
